import React from 'react';
import { CommonCard } from '../../../IssuanceUniversityCard/info/components/styled';
import { Title, Content, Wrapper, Card } from '.';
import WhiteContainer from '@/presentation/modules/procedures/components/ContainerProcedure/WhiteContainer';
import Link from '@/presentation/reusables/Link';

interface ProcedureInfoComponentProps {
  inRegister?: boolean;
}
const ProcedureInfoComponent = ({
  inRegister
}: ProcedureInfoComponentProps) => (
  <WhiteContainer inRegister={inRegister}>
    <Wrapper>
      <Card>
        <Title>Información del trámite</Title>
        <Content>
          La UTP tiene opciones más flexibles para ti. Con las modalidades
          Semipresencial y Virtual podrás tener una mayor oferta de:
          <br />
          <br />
          {/* La UTP tiene disponible las siguientes modalidades:{' '} */}
          {/* <b>
              Modalidad Presencial, Modalidad Semipresencial y Modalidad A
              Distancia.{' '}
            Dependiendo de la carrera que estudies, puedes tener disponible
            todas las modalidades o algunas de ellas. */}
        </Content>
      </Card>
      {/* <OptionsDetail /> */}

      {/* <div>
          <ul
            style={{
              listStyle: 'disc',
              marginLeft: '16px',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '20px',
              color: '#161D1F'
            }}
          >
            <li>
              Tendrás acceso a la opción A distancia -100% virtual, si para el
              ciclo que aplicas el cambio tienes 24 años.
            </li>
            <li>
              Podrás ver el cambio impactado a partir de la matrícula de{' '}
              {applySince}.
            </li>
            <li>
              Podrías tener un cambio de nombre en la carrera pero no implica un
              cambio de malla curricular.
            </li>
            <li>
              Si solicitaste un cambio de carrera en los últimos días y las
              opciones brindadas corresponden a tu carrera anterior, deberás
              registrar una solicitud a tráves de{' '}
              <button
                type="button"
                onClick={handlerRedirectPush}
                className="spanEllipsis"
              >
                https://portal.utp.edu.pe/tramites/ticketera/registro
              </button>
            </li>
          </ul>
        </div> */}

      <div>
        {/* <p>Tomar en cuenta lo siguiente:</p> */}
        <div>
          <ul
            style={{
              listStyle: 'disc',
              marginLeft: '16px',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '20px',
              color: '#161D1F'
            }}
          >
            <li>
              {/* Las{' '} */}
              {/* <b>
                  <u>evaluaciones</u>
                </b>{' '} */}
              <b>Cursos virtuales en vivo: </b>
              Las clases tienen un horario específico y serán realizadas por la
              plataforma de zoom.
            </li>
            <li>
              <b>Cursos virtuales 24/7: </b>
              Tendrás la flexibilidad de conectarte en cualquier momento y todo
              tu material estará disponible 24/7 por UTP+class.
              {/* En la parte virtual de la carrera podrás elegir{' '}
                <b>cursos remotos vía Zoom “en vivo”</b> (síncronos) o{' '}
                <b>cursos virtuales a través de la plataforma</b> (asíncronos
                sin horario). */}
            </li>
            {/* <li>
                En alguna carrera particular, el nombre de la carrera podría
                tener alguna variación, pero no implica ningún cambio en la
                malla curricular.
              </li> */}
          </ul>
        </div>
      </div>
      <br />
      <p>
        Recuerda que las evaluaciones serán en la modalidad de estudio de cada
        curso. Si tu curso es presencial, las evaluaciones del curso serán
        presenciales. Si tu curso es virtual, las evaluaciones del curso serán
        virtuales.
      </p>
      <br />
      <p>
        En alguna carrera particular, el nombre de la carrera podría tener
        alguna variación, pero no implica ningún cambio en la malla curricular.
      </p>
      <br />
      <p>
        Conoce más sobre las modalidades disponibles{' '}
        <Link
          linkType="external"
          url="https://view.genially.com/665e1657cf86150014f28544?utm_campaign=Cambio+de+Modalidad&utm_medium=bitly&utm_source=General"
          linkName="aquí."
        />
      </p>
    </Wrapper>
    {/* <Pin1 message="Para más información ingresa a: <a href='https://utp.edu.pe' target='_blank' style='color: rgb(91, 54, 242);'>https://utp.edu.pe</a>" /> */}
  </WhiteContainer>
);

ProcedureInfoComponent.defaultProps = {
  inRegister: false
};

const StepsToFollowComponent = () => (
  <CommonCard>
    <div className="requirements__container">
      <p className="requirements__container--question">
        <strong>Pasos a seguir:</strong>
      </p>
      <div>
        <ul
          style={{
            listStyle: 'auto',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '20px',
            color: '#161D1F',
            marginTop: '12px',
            marginLeft: '15px'
          }}
        >
          <li>Revisa la carrera y modalidad actual con la que cuentas.</li>
          <li>
            Selecciona el ciclo y la opción de estudios a la que quieras
            cambiar.
          </li>
          <li>
            Recuerda que el cambio se hará para tu siguiente ciclo matriculado.
          </li>
        </ul>
      </div>
    </div>
  </CommonCard>
);

export { ProcedureInfoComponent, StepsToFollowComponent };
